import { createUniqueCustomProperties } from '../../../utils/createUniqueCustomProperty';

// Shared CSS variables used amongst `Table` and its subcomponents.
// Using CSS variables prevents prop drilling, elminates the need
// to use JS for responsiveness, etc.
export const Vars = createUniqueCustomProperties('Table', [
  'frozenCellHorzShadowOpacity',
  'frozenCellVertShadowOpacity',
]);
